import React from "react";
import { Star, MapPin, ArrowRight, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

/**
 * @param {{ course: any, onSelect: (course: any) => void, index: number }} props
 */
export default function CourseCard({ course, onSelect, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      onClick={() => onSelect(course)}
      className="rounded-xl overflow-hidden shadow-md bg-white flex flex-col cursor-pointer hover:shadow-xl transition-shadow"
    >
      {/* Image */}
      <div className="relative h-44 shrink-0">
        <img
          src={course.image || "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&q=80"}
          alt={course.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

        {/* GOLF badge */}
        <span className="absolute top-3 left-3 bg-[#0B2421] text-[#D4AF37] text-xs font-bold px-2.5 py-1 rounded-md">
          GOLF
        </span>

        {/* Rating badge */}
        {course.rating && (
          <span className="absolute top-3 right-3 bg-white/95 text-amber-500 text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1">
            <Star className="h-3 w-3 fill-amber-400" />
            {course.rating}
          </span>
        )}
      </div>

      {/* Content */}
      <div className="p-4 flex flex-col gap-2.5 flex-1">
        {/* Name + Location */}
        <div>
          <h3 className="font-bold text-[#0B2421] text-base leading-snug">{course.name}</h3>
          <div className="flex items-center gap-1 mt-0.5 text-xs text-gray-500">
            <MapPin className="h-3 w-3 shrink-0" />
            <span>{course.city}, {course.country}</span>
          </div>
        </div>

        {/* Description */}
        <p className="text-xs text-gray-500 line-clamp-2 leading-relaxed">{course.description}</p>

        {/* Fees included */}
        {course.fees_included?.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {course.fees_included.map((fee) => (
              <span key={fee} className="inline-flex items-center gap-1 text-[10px] font-medium bg-[#0B2421]/8 text-[#0B2421] px-2 py-0.5 rounded-full border border-[#0B2421]/15">
                <CheckCircle2 className="h-2.5 w-2.5 text-emerald-600" />
                {fee}
              </span>
            ))}
          </div>
        )}

        {/* View details button */}
        <button
          onClick={(e) => { e.stopPropagation(); onSelect(course); }}
          className="mt-auto w-full bg-[#0B2421] hover:bg-[#0B2421]/85 text-white text-sm font-semibold py-2.5 rounded-lg flex items-center justify-center gap-1.5 transition-colors"
        >
          View Details
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </motion.div>
  );
}
